const readAsBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

// Dosya base64 olarak talep görseli ucuna gönderilir; dönen herkese açık adres talebe kaydedilir
export const uploadTicketPhoto = async (file, ticketStore) => {
    const response = await ticketStore.uploadTicketPhoto({
        file: {
            originalname: file.name,
            mimetype: file.type,
            buffer: await readAsBase64(file)
        }
    });
    if (!response?.data?.url) {
        throw new Error("upload failed");
    }
    return response.data.url;
};
